import {
    AddProductPayload,
    BuyBookingPayload,
    BuyProductPayload,
} from '../types/EcomSDK';

const waitUntilEcomSDKIsReady = async () => {
    if (!window._ecomm) {
        throw new Error('_ecomm is not defined');
    }
    await window._ecomm.ready;
};

export const buyBooking = async (payload: BuyBookingPayload) => {
    await waitUntilEcomSDKIsReady();
    return await window._ecomm!.buyBooking(payload);
};

export const addProduct = async (payload: AddProductPayload) => {
    await waitUntilEcomSDKIsReady();
    return await window._ecomm!.addProduct(payload);
};

export const buyProduct = async (payload: BuyProductPayload) => {
    await waitUntilEcomSDKIsReady();
    return await window._ecomm!.buyProduct(payload);
};
